module.exports = __webpack_public_path__ + "media/images/front/icon_up_d-af44a141a632d6a10a8016a614479a77.png";